/* bj-cart-v2: variant B of the cart (Splitly cart test).

   Quantity, remove, note, checkout and every section re-render run on Dawn's
   own cart.js. This file adds only what Dawn has no code for: adding a
   cross-sell product from the cart without leaving it, and the carousel arrows.
   Works on the /cart page (cart_type = page, the live setting) and, should the
   theme ever switch to the drawer, inside Dawn's cart-drawer as well.

   Safety contract (memory: feedback_no_agent_shopify_injection):
   - nothing here patches window.fetch / XHR or touches the native cart forms;
   - one delegated click listener on document, gated on the .bjc root, so it is
     a no-op for control visitors and survives the markup being re-inserted via
     innerHTML on every cart change;
   - adds go through the native /cart/add.js with Shopify section rendering,
     one request in flight per variant, abortable with a timeout;
   - any failure re-enables the button and leaves the native cart untouched. */
/* Owner preview (Rafal 2026-09-23): /cart?bj_cart_preview=b|a pins THIS browser to a cart
   variant of the live Splitly cart test (localStorage + cart attribute, the same pair the tracker
   writes), then drops the parameter. Customers never carry it; no fetch/XHR patching. */
(function () {
  try {
    var q = new URLSearchParams(location.search), v = q.get('bj_cart_preview');
    if (v !== 'a' && v !== 'b') return;
    var key = 'ab_test_18_variant', attrs = {};
    attrs[key] = v;
    localStorage.setItem(key, v);
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }) }).then(function () {
      q.delete('bj_cart_preview');
      var rest = q.toString();
      location.replace(location.pathname + (rest ? '?' + rest : ''));
    });
  } catch (e) {}
})();

(function () {
  'use strict';
  var TIMEOUT_MS = 10000;
  var inflight = Object.create(null);

  function pageTargets() {
    // Same pair cart.js re-renders on a quantity change (see CartItems.getSectionsToRender).
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    if (!items || !items.dataset.id) return null;
    var list = [{ el: items, id: items.dataset.id }];
    if (foot && foot.dataset.id) list.push({ el: foot, id: foot.dataset.id });
    return list;
  }

  function swapSections(targets, sections, itemCount) {
    targets.forEach(function (t) {
      var html = sections && sections[t.id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.js-contents');
      var mine = t.el.querySelector('.js-contents');
      if (fresh && mine) mine.innerHTML = fresh.innerHTML;
    });
    var empty = itemCount === 0;
    var ci = document.querySelector('cart-items');
    if (ci) ci.classList.toggle('is-empty', empty);
    var foot = document.getElementById('main-cart-footer');
    if (foot) foot.classList.toggle('is-empty', empty);
  }

  function addToCart(btn) {
    var card = btn.closest('[data-bjc-card]');
    var select = card && card.querySelector('[data-bjc-variant]');
    var id = (select && select.value) || btn.getAttribute('data-bjc-add');
    if (!id || inflight[id] || !window.routes || !routes.cart_add_url) return;

    var drawer = document.querySelector('cart-drawer');
    var page = drawer ? null : pageTargets();
    if (!drawer && !page) return; // nothing we know how to refresh: leave the native cart alone

    var sectionIds = drawer
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : page.map(function (t) { return t.id; }).concat(['cart-icon-bubble']);

    inflight[id] = true;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Dodaję';

    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    body.append('properties[_src]', 'koszyk');
    body.append('sections', sectionIds.join(','));
    body.append('sections_url', location.pathname);

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status) throw new Error((res && (res.description || res.message)) || 'add failed');
        if (drawer) {
          drawer.renderContents(res);
        } else {
          // /cart/add.js returns the added line, not the cart, so the item count comes
          // from a follow-up read of the freshly rendered footer state via /cart.js.
          swapSections(page, res.sections, undefined);
          fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { swapSections([], null, cart.item_count); })
            .catch(function () {});
        }
        var bubble = res.sections && res.sections['cart-icon-bubble'];
        var bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubble && bubbleEl) {
          var b = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
          if (b) bubbleEl.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
      })
      .then(function () {
        if (timer) clearTimeout(timer);
        delete inflight[id];
      });
  }

  function scrollTrack(root, dir) {
    var track = root.querySelector('[data-bjc-track]');
    if (!track) return;
    var card = track.querySelector('[data-bjc-card]');
    var step = card ? card.getBoundingClientRect().width + 8 : 150;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('.bjc');
    if (!root) return;
    var add = t.closest('[data-bjc-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var nav = t.closest('[data-bjc-nav]');
    if (nav) { e.preventDefault(); scrollTrack(root, Number(nav.getAttribute('data-bjc-nav')) || 1); }
  });
})();
